
import { map } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormControl, ValidatorFn, FormArray, ValidationErrors } from '@angular/forms';

export class CustomValidator {
    static noWhitespaceValidator(control: FormControl) {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true };
    }

    static arrayRequiredValidator(control: FormControl) {
        if (control.value.length === 0) {
            return { required: true };
        } else {
            return null;
        }
    }

    static atLeastOneFormArrayValidator(fa: FormArray): ValidationErrors {
        let valid = false;
        if (!fa) { return null; }
    
        for (let x = 0; x < fa.length; ++x) {
            if (fa.at(x).value.selected === true) {
                valid = true;
                break;
            }
        }
        return valid ? null : {
            multipleCheckboxRequireOne: true
        };
    }
    
}